import {useMemo, useRef} from 'react'

const useInitLoader = isLoading => {
  const isInitLoading = useRef(false)
  const isDoneInitLoading = useRef(false)

  const showLoader = useMemo(() => {
    if (isLoading && !isInitLoading.current) {
      isInitLoading.current = true
    }
    if (isInitLoading.current && !isLoading) {
      isDoneInitLoading.current = true
    }
    return isLoading || !isInitLoading.current
  }, [isInitLoading, isLoading])

  return [showLoader, isDoneInitLoading.current]
}

export default useInitLoader
